<template>
  <div>
    <template v-if="viewPage == true">
      <div class="modal fade" id="batchSummary" tabindex="-1" role="dialog" aria-labelledby="batchSummaryLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-body batchSummary-payment-popup text-left p-4">
              <div class="popup-head line-head">
                <h2 class="pb-2"> Summary </h2>
              </div>
              <div class="row normal-ib-space mt-3">
                <div class="col-md-12 mb-3">
                  <table width="100%" v-if="batchSummary != null">
                    <tr>
                      <td> Shops inserted </td>
                      <td id="inserted_rows"> {{ inserted }} </td>
                    </tr>
                    <tr>
                      <td> Discrepant Shops (Invalid Phone No.) </td>
                      <td id="discrepant_rows"> {{ discrepants }} </td>
                    </tr>
                    <tr>
                      <td> Updated Shops </td>
                      <td id="existing_rows"> {{ already_exist }} </td>
                    </tr>
                  </table>
                </div>
                <div class="col align-right">
                  <button class="btn btn-primary" v-on:click="proceedToShops"> Proceed </button>
                  <button class="btn btn-primary" v-if="discrepantShops.length > 0" v-on:click="csvExport"> Download Discrepants</button>
                  <button class="btn btn-primary" v-if="updatedShops.length > 0" v-on:click="csvExportExist"> Download Updated</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="clearfix">
        <div class="page-top mb-1 mb-3 align-center clearfix">
          <h1 class="float-left"> Shops Bulk Upload </h1>
          <div class="progress-bar-holder">
            <div class="progress step-one">
              <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="" aria-valuemin="0" aria-valuemax="100"></div>
            </div>
            <ul class="prgress-number">
              <li class="progress-number-list active">
						<span class="bullet">
							1
						</span>
                <p> Upload </p>
              </li>
              <li class="progress-number-list" id="progressNumberListTwo">
						<span class="bullet">
							2
						</span>
                <p> Field Mapping </p>
              </li>
            </ul>
          </div>
          <button class="btn btn-primary float-right mr-1" id="process_dropzone_queue" v-show="proceedButtonflag"> Proceed </button>
          <router-link class="btn btn-primary float-right mr-1" to="/shops"> Cancel </router-link>
        </div>
        <div class="batch-upload-main">
          <div class="batch-upload-inner">
            <div class="upload-sheet" v-show="previewMapField == false">
              <label for="" class="label block-label upload-label"> Upload a CSV <i class="fas fa-question-circle" data-toggle="tooltip" data-placement="top" title=".CSV is an Microsoft Excel file format which is a requirement for Payroll Plus to read your file. You can save your Excel file into a .CSV file using 'save as' option listed under file menu on your Excel program."></i>
              </label>
              <p> You can also download a sample template <a :href="`${$global.aws_base_url}/csv/BulkShopUpload.csv`">here</a>. </p>
              <form  method="post" class="box dropzone drozone-label dz-clickable dropzone content mt-4" action="/upload" id="drop" data-toggle="tooltip" data-placement="left" title="<p class='align-left'>Your CSV file must have the following in order to upload bulk Shops: <br/>
							1. Shop Name.<br/>
							2. Shop Owner Name.<br/>
							3. Phone.<br/>
							4. Address.<br/></p>">
                <div class="box__input dz-message">
                  <label class="drozone-label" for="file">
                    <img  id="uploadIcon" for="file" src="/images/svgs/upload-icon.svg" alt="" class="upload">
                    <span for="file" class="filename"> Drop your file here </span>
                  </label>
                  <label class="uploadedFileName">Drop your file here</label>
                </div>
              </form>
              <em class="dropzone-or"> Or </em> <label id="selectFromComputer" class="btn btn-primary select-file-btn"> Select from your computer </label>
            </div> <!-- upload sheet -->
            <div class="previewMapField" v-show="previewMapField == true">
              <div class="mandatory-fields mb-4">
                <label for="" class="label block-label upload-label mb-3"> Mandatory Information <i class="fas fa-question-circle" data-toggle="tooltip" data-placement="top" title="These fields are required for Payroll Plus to process your sheet."></i> </label>
                <div class="mandatory-tags">
                  <div class="mandatory-fields-inner">
                    <div class="mandatory-field-col"> <span class="map-value" title="Shop Name"> <i v-show="mand_shop_name" class="fas fa-check"></i> Shop Name </span> </div>
                    <div class="mandatory-field-col"> <span class="map-value" title="Shop Owner Name"> <i v-show="mand_shop_owner_name" class="fas fa-check"></i> Shop Owner Name </span> </div>
                    <div class="mandatory-field-col"> <span class="map-value" title="Phone"> <i v-show="mand_phone" class="fas fa-check"></i> Phone </span> </div>
                    <div class="mandatory-field-col"> <span class="map-value" title="Address"> <i v-show="mand_address" class="fas fa-check"></i> Address </span> </div>
                  </div>
                </div>
              </div>
              <label for="" class="label block-label upload-label"> Preview and map your identifiers <i class="fas fa-question-circle" data-toggle="tooltip" data-placement="top" title="Please review the below identifiers in line with the columns in your sheet."></i>
              </label>
              <p> Please check if we have correctly picked your data. </p>
              <div class="fields-mapping mt-4" id="fieldmapping_table">
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-if="viewPage == null">
      <preLoader></preLoader>
    </template>
    <template v-if="viewPage == false">
      <notAllowed></notAllowed>
    </template>
  </div>
</template>

<script>
export default {
  data() {
    return {
      viewPage : true,
      previewMapField : false,
      fileAdded : false,
      dropZoneObject : null,

      mand_shop_name : false,
      mand_phone : false,
      mand_address : false,
      mand_shop_owner_name : false,

      proceedButtonflag : false,
      batchSummary : [],
      discrepantShops : {},
      updatedShops : {},
      inserted : null,
      discrepants : null,
      already_exist : null,
    }
  },
  methods: {
    processDropzoneQueue(){

    },
    handleGeneratePayrollButton(){
      if(this.fileAdded == true){
        $('a#payroll_proceed_top,a#payroll_proceed_bottom').removeAttr('disabled','disabled').addClass('active');
        if(this.isAPIAvailable()){
          $.when(this.printTable(this.dropZoneObject.files[0]));
        }
      }else{
        $('a#payroll_proceed_top,a#payroll_proceed_bottom').attr('disabled','disabled').removeClass('active');
      }
    },
    csvExportExist() {
      let that = this;
      let csvContent = "data:text/csv;charset=utf-8,";
      csvContent += [
        [
          'Shop Name',
          'Shop Owner Name',
          'Phone',
          'Address'
        ],
        ...that.updatedShops.map(item => item)
      ]
          .join("\n")
          .replace(/(^\[)|(\]$)/gm, "");
      const data = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", data);
      link.setAttribute("download", "Updated Shops.csv");
      link.click();
    },
    csvExport() {
      let that = this;
      let csvContent = "data:text/csv;charset=utf-8,";
      csvContent += [
        [
          'Shop Name',
          'Shop Owner Name',
          'Phone',
          'Address'
        ],
        ...that.discrepantShops.map(item => item)
      ]
          .join("\n")
          .replace(/(^\[)|(\]$)/gm, "");
      const data = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", data);
      link.setAttribute("download", "Descrepant Shops.csv");
      link.click();
    },
    proceedToShops(){
      $('#batchSummary').modal('hide');
      this.$router.push('shops');
    },
    initDropZone() {
      var that = this;
      Dropzone.options.drop = {
        addRemoveLinks: true,
        paramName: 'file',
        maxFilesize: 2, // MB
        uploadMultiple: false,
        maxFiles: 1,
        minFiles: 1,
        queueLimit:1,
        url: that.$global.base_url+'api/bulkShopUpload',
        acceptedFiles: '.csv',
        autoProcessQueue:false,
        headers: window.axios.defaults.headers.common,
        init: function(){
          var _this = this;
          that.dropZoneObject = this;
          var selectedFile = document.getElementById('selectFromComputer');
          selectedFile.addEventListener('click',function(){
            _this.hiddenFileInput.click();
          });
          this.on("maxfilesexceeded", function(file) {
            this.removeAllFiles();
            this.addFile(file);
          });
          this.on('removedfile',function(file){
            that.fileAdded = false;
            $('div.box__input').show();
          }),
              this.on("addedfile", function(file) {
                that.fileAdded = true;
                that.checkFileForErrors(file);
                that.handleGeneratePayrollButton();
              });
          var submitButton_top 	= document.querySelector("#process_dropzone_queue");
          function processFileLocal(){
            if(that.isAPIAvailable()){
              $.when(that.printTable(that.dropZoneObject.files[0]));
            }
          }
          function processQueueLocal(){
            $('div.progress').addClass('step-three').removeClass('step-two');
            that.dropZoneObject.processQueue(); // Tell Dropzone to process all queued files.
          }
          submitButton_top.addEventListener("click", function(e) {
            processQueueLocal();
          });
          that.dropZoneObject.on("sending", function(file, xhr, formData) {
            that.$Progress.start();
            // Will send the filesize along with the file as POST data.
            formData.append("filesize", file.size);
            var mapIdentifier = [];
            var selVal = '';
            $( "select.selectpicker" ).each(function() {
              selVal = $(this).find('option:selected').val();
              mapIdentifier.push(selVal);
              selVal = '';
            });
            formData.append("mapIdentifier", JSON.stringify(mapIdentifier));
            formData.append("_token",$('meta[name="csrf-token"]').attr('content'));
          });

          that.dropZoneObject.on("totaluploadprogress", function(progress) {

          });

          that.dropZoneObject.on("uploadprogress", function(file, progress, bytesSent) {
            // Update progress bar with the value in the variable "progress", which
            // is the % total upload progress from 0 to 100
            var progressBar = Math.floor(progress);
            if(progressBar == 100){
            }
          });

          that.dropZoneObject.on("success", function(file, obj) {
            if(obj.code == "200") {
              that.showToastBox('success','File has been uploaded');
              that.batchSummary = obj.data;

              that.inserted = obj.data.inserted;
              that.discrepants = obj.data.discrepants;
              that.already_exist = obj.data.already_exist;
              $('#inserted_rows').html(that.inserted);
              $('#discrepant_rows').html(that.discrepants);
              $('#existing_rows').html(that.already_exist);

              that.discrepantShops = obj.discrepantShops;

              that.updatedShops = obj.updatedShops;
              $('#batchSummary').modal('show');
              that.$Progress.finish();
            }else if(obj.code == "204"){
              that.showAlertBox('error',obj.msg);
            }else{
              that.showAlertBox('error','Error in file');
            }
          });
          that.dropZoneObject.on('error',function(file,errorMessage,xhr){
            if(!file.accepted){
              this.fileAdded = false;
              that.showAlertBox('error','Error in file');
              this.removeFile(file);
            }
            var msg = 'Error:'+xhr.status+' '+xhr.statusText;
            that.showAlertBox('error','Error in file', msg);
            file.status = Dropzone.QUEUED;
          });
        }
      };
      $('.cross').on('click', function(e){
        that.dropZoneObject.removeAllFiles();
        $('label.uploadedFileName').html('Drop your file here');
      });
    },
    isAPIAvailable() {
      // Check for the various File API support.
      if (window.File && window.FileReader && window.FileList && window.Blob) {
        // Great success! All the File APIs are supported.
        return true;
      } else {
        var error_message = 'The HTML5 APIs used in this form are only available in the following browsers:<br /> - Google Chrome: 13.0 or later<br /> - Mozilla Firefox: 6.0 or later<br /> - Internet Explorer: Not supported (partial support expected in 10.0)<br /> - Safari: Not supported<br /> - Opera: Not supported';
        this.showAlertBox('error',error_message);
        return false;
      }
    },
    printTable(file) {
      var reader = new FileReader();
      reader.readAsText(file);
      var that = this;
      reader.onload = function(event){
        var csv = event.target.result;
        var data = $.csv.toArrays(csv);
        var test 		= '';
        var selected 	= '';
        var col = [];
        for(var row in data) {
          if(row > 1) break;
          for(var item in data[row]) {
            if(row == 0){
              col[item] = [data[row][item]];
            }else{
              col[item].push(data[row][item]);
            }
          }
        }
        for(var row1 in col) {
          var rowName = '';
          var rowValue = '';
          var comboBox = '';
          var fieldMap = false;
          for(var item1 in col[row1]) {
            if(item1 > 1){ break; }
            if(item1 == 0){
              rowName = col[row1][item1];
            }else{
              rowValue += '<p>' + col[row1][item1] + '</p>';
            }
          }

          // check for if you find the Name in you ddList
          if(rowName.trim().toLocaleLowerCase() == 'shop_name'){
            that.mand_shop_name = fieldMap = true;
          }
          if(rowName.trim().toLocaleLowerCase() == 'shop_owner_name'){
            that.mand_phone = fieldMap = true;
          }
          if(rowName.trim().toLocaleLowerCase() == 'phone'){
            that.mand_address = fieldMap = true;
          }
          if(rowName.trim().toLocaleLowerCase() == 'address'){
            that.mand_shop_owner_name = fieldMap = true;
          }
         
          comboBox += '<select name="'+row1+'" class="selectpicker show-menu-arrow custom-select2" data-size="5">';
          comboBox += '<option value="do-not"> - Select - </option>';
          selected = (rowName.trim().toLocaleLowerCase() == 'shop_name') ? 'selected' : '';
          fieldMap = (rowName.trim().toLocaleLowerCase() == 'shop_name') ? true : fieldMap;
          comboBox += '<option value="shop_name" '+selected+'>Shop Name</option>';
          selected = (rowName.trim().toLocaleLowerCase() == 'shop_owner_name') ? 'selected' : '';
          fieldMap = (rowName.trim().toLocaleLowerCase() == 'shop_owner_name') ? true : fieldMap;
          comboBox += '<option value="shop_owner_name" '+selected+'>Shop Owner Name</option>';
          selected = (rowName.trim().toLocaleLowerCase() == 'phone') ? 'selected' : '';
          fieldMap = (rowName.trim().toLocaleLowerCase() == 'phone') ? true : fieldMap;
          comboBox += '<option value="phone" '+selected+'>Phone</option>';
          selected = (rowName.trim().toLocaleLowerCase() == 'address') ? 'selected' : '';
          fieldMap = (rowName.trim().toLocaleLowerCase() == 'address') ? true : fieldMap;
          comboBox += '<option value="address" '+selected+'>Address</option>';
          comboBox += '</select>';
          if(fieldMap == true){
            test += '<div class="row mapped align-items-center">';
          }else{
            test += '<div class="row align-items-center">';
          }
          test += '<div class="col-md-1"><div class="fields-mapping-inner"><i class="fas fa-check-circle"></i></div></div>';
          test += '<div class="col-md-7"><div class="fields-mapping-inner"><p> '+rowName+' </p><p> '+rowValue+' </p></div></div>';
          test += '<div class="col-md-4"><div class="fields-mapping-inner">';
          test += comboBox;
          test += '</div></div>';
          test += '</div>';
        }
        $('#fieldmapping_table').html(test);
        that.previewMapField = true;
        that.generateButtonProccess();
        $('select.selectpicker').selectpicker('refresh');
        that.assignComboFunction();
        $('div.progress').addClass('step-two');
      };
      reader.onerror = function(){ this.showAlertBox('error','Unable to read ' + file.fileName); }.bind(this);
    },
    generateButtonProccess(){
      if(this.mand_shop_name == true && this.mand_phone == true && this.mand_address == true && this.mand_shop_owner_name == true){
        this.proceedButtonflag = true;
      }else{
        this.proceedButtonflag = false;
      }
    },
    checkForMandField(){
      $( "select.selectpicker" ).each(function() {
        this.mand_shop_name = this.mand_phone = this.mand_address = this.mand_shop_owner_name = false;
        var selVal = $(this).find('option:selected').val();
        if(selVal.trim().toLowerCase() == 'shop_name') this.mand_shop_name = true;
        if(selVal.trim().toLowerCase() == 'phone') this.mand_phone = true;
        if(selVal.trim().toLowerCase() == 'address') this.mand_address = true;
        if(selVal.trim().toLowerCase() == 'shop_owner_name') this.mand_shop_owner_name = true;
      });

    },
    assignComboFunction(){
      var that = this;
      // Auto Mapped value make disabled
      $('select.selectpicker').each(function(index,obj){
        $('select.selectpicker option[value="'+obj.value+'"]').attr('disabled',true);
      });
      $(that.$el).find('.selectpicker').selectpicker('refresh');
      var previous;
      $('select.selectpicker').on('shown.bs.select',function(){
        previous = this.value;
      }).change(function(){
        var selVal = $(this).find('option:selected').val();
        $('select.selectpicker option[value="'+previous+'"]').attr('disabled',false);
        //hide the department, branch and city field sets if deselect
        $('select.selectpicker option[value="'+selVal+'"]').attr('disabled',true);
        $(that.$el).find('.selectpicker').selectpicker('refresh');

        var flag = false;
        that.checkForMandField();
        if(selVal.trim().toLowerCase() == 'shop_name') that.mand_shop_name = true;
        if(selVal.trim().toLowerCase() == 'phone') that.mand_phone = true;
        if(selVal.trim().toLowerCase() == 'address') that.mand_address = true;
        if(selVal.trim().toLowerCase() == 'shop_owner_name') that.mand_shop_owner_name = true;

        that.generateButtonProccess();
      });
    },
    checkFileForErrors(file){
      var reader = new FileReader();
      reader.readAsText(file);
      var that = this;
      reader.onload = function(event){
        var csv = event.target.result;
        var data = $.csv.toArrays(csv);
        var col = [];
        var column = false;
        for(var row in data) {
          if(row == 0){
            for(var item in data[row]) {
              var value = data[row][item];
              value = value.replace(/[^\w\s]/gi,'');
              col.push(value);
            }
          }else{
            break;
          }
        }
        if(col.length < 3 && that.fileAdded == true){
          column = true;
          that.showAlertBox('error','Missing column');
        }
        if(column == true){
          that.dropZoneObject.removeAllFiles();
        }
      };
      reader.onerror = function(){ this.showAlertBox('Unable to read ' + file.fileName); }.bind(this);
    },
  },
  created() {
  },
  mounted(){
    var that = this;
    this.initDropZone();
    $(".drozone-label").tooltip({
      html	: true,
      template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner large"></div></div>',
    });
    $("#drop").dropzone();
    $(window.document).on('show.bs.modal', '.modal', function (event) {
      var zIndex = 1040 + (10 * $('.modal:visible').length);
      $(this).css('z-index', zIndex);
      setTimeout(function() {
        $('.modal-backdrop').not('.modal-stack').css('z-index', zIndex - 1).addClass('modal-stack');
      }, 0);
    });

    /*this.$Progress.start();
    $('.selectpicker').selectpicker();
    this.can('bill_payments').then(result => {
        this.bill_payments = result.bill_payments;
    }).then(result => {
        if(this.bill_payments == true){
            this.viewPage = true;
            this.$Progress.finish();
        }else{
            this.$Progress.finish();
        }
    });*/
  }
}
</script>
